import * as React from "react";
import { Breadcrumbs } from "@grandvisionhq/common";
import { Container } from "@grandvisionhq/elements";
import { useIntl, useFeatureToggles } from "@grandvisionhq/state";
import { LocaleUtils, StringUtils } from "@grandvisionhq/utils";
import { useBloomreachPageRoutes } from "../../../../../../hooks/hooks/use-bloomreach-page-routes.js";
import { useBrPageContext } from "../../../../../../context/context/context.js";
import { getUrl } from "../../../../../../utils/utils/get-url.js";
const CmsContentBreadcrumbs = ({ url, documentName }) => {
  const breadcrumbs = useBreadcrumbs(url);
  if (!breadcrumbs || breadcrumbs.length < 2) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Breadcrumbs, { documentName, pages: breadcrumbs }));
};
function useBreadcrumbs(url = "") {
  const { getLabel, hasLabel, locale: defaultLocale } = useIntl();
  const { routes } = useBloomreachPageRoutes();
  const { isMultilingualEnabled } = useFeatureToggles();
  const page = useBrPageContext();
  const locale = LocaleUtils.getLocaleFromUrl(url) || defaultLocale;
  const localeStr = locale.replace("-", "_");
  const [path = "", queryString = ""] = url?.split("?");
  let segments = path.split("/");
  if (page?.isPreview() && path.startsWith("/site/_cmsinternal")) {
    segments = [...segments].filter((s) => s !== "" && s !== localeStr).slice(3, segments.length - 1);
  } else {
    segments = segments.filter((s) => s !== "" && s !== localeStr);
  }
  return [
    {
      name: getLabel(`breadcrumb.breadcrumb.home`),
      url: page?.isPreview() ? page?.getUrl(routes.root) : routes.root
    },
    ...segments.map(
      (currentSegment, index) => createUrlBreadcrumb({
        currentSegment,
        segments,
        queryString,
        index,
        getLabel,
        hasLabel,
        page,
        locale: isMultilingualEnabled ? localeStr : void 0
      })
    )
  ];
}
function createUrlBreadcrumb({
  segments,
  currentSegment,
  queryString,
  index,
  getLabel,
  hasLabel,
  page,
  locale
}) {
  const previous = segments.slice(0, index).join("/");
  const labelKey = `breadcrumb.breadcrumb.${currentSegment}`;
  const name = hasLabel(labelKey) ? getLabel(labelKey) : StringUtils.upFirst(currentSegment.replace(/-/g, " "));
  let url = previous ? `/${previous}/${currentSegment}` : `/${currentSegment}`;
  if (queryString) url += `?${queryString}`;
  if (locale) {
    url = `/${locale}${url}`;
  }
  return { url: getUrl(url, page), name };
}
export {
  CmsContentBreadcrumbs,
  CmsContentBreadcrumbs as default
};
//# sourceMappingURL=ContentBreadcrumbs.js.map
